import { request } from '@helpers/request';

/**
 * Get the account list
 */
const getDepositsListApi = () => request('deposits');

export default getDepositsListApi;
